import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import {
    AvailableCarIncludes,
    CarIncludesMap,
} from '../../../CarIncludes/car-includes.type';
import { CarIncludeItem } from '../../../CarIncludes/car-includes-item';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { TFunction } from 'i18next';
import { CarTypeBadge } from '../../../CarTypeBadge/CarTypeBadge';
import Typography from '@/components/shared/typography/typography.component';

export const PriceBreakDownCarIncludes = ({
    carType,
    t,
}: {
    carType: CarTypesEnum;
    t: TFunction;
}) => {
    const { i18n } = useTranslation();
    const requiredIncludes = CarIncludesMap[carType];
    const toBeIcluded = requiredIncludes.map(i => AvailableCarIncludes[i]);
    return (
        <div className="px-3 py-4 rounded-xl border  border-gray-200 relative overflow-hidden">
            <div className="absolute top-0 end-0">
                <CarTypeBadge
                    carType={carType}
                    className="ar:rounded-tl-xl ar:rounded-br-xl en:rounded-tr-xl en:rounded-bl-xl"
                />
            </div>

            <div className="flex flex-col gap-3">
                <Typography className="text-gray-800 text-body1SemiBold">
                    {t('CarProfile.CarIncludesTitle', {
                        count: toBeIcluded.length,
                    })}
                </Typography>
                <div className="flex flex-col gap-2">
                    {toBeIcluded.map((item, idx) => {
                        return (
                            <CarIncludeItem
                                item={item}
                                key={idx}
                                lang={i18n.language as AVAILABLE_LANGUAGES}
                                itemTextVariant="text-captionMedium"
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
